import { createStyles, TextProps as MantineTextProps } from '@mantine/core';
import COLORS_FLAT, {
  T_COLORS_FLAT,
} from '@styles/colors/themes/beam/beam-flat';
import TYPOGRAPHY_FLAT, {
  T_TYPOGRAPHY_FLAT,
} from '@styles/fonts/fontsizes/typography-flat';

export interface TextParams {
  text?: keyof T_TYPOGRAPHY_FLAT;
  textColor?: keyof T_COLORS_FLAT;
  inherit?: MantineTextProps['inherit'];
}
export const useStyles = createStyles((_, params: TextParams) => {
  const { text, textColor, inherit } = params;
  const textStyles = text ? TYPOGRAPHY_FLAT[text] : null;
  const color = textColor ? COLORS_FLAT[textColor] : textStyles?.color;

  return {
    root: {
      ...textStyles,
      color: inherit ? 'inherit' : color,
      margin: 0,
    },
  };
});
